/** Last non-data App location — used as returnPath when the first tab opens. */
let lastServicePath = '/dashboard'

export function noteServicePath(path: string): void {
  if (path) lastServicePath = path
}

export function getLastServicePath(): string {
  return lastServicePath || '/dashboard'
}

/** Test-only reset. */
export function _resetLastServicePathForTests(): void {
  lastServicePath = '/dashboard'
}
